<template>
  <div class="locale-changer">
    <select v-model="$i18n.locale" name="language" v-on:change="updateurl">
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'locale-changer',
  data () {
    return { langs: ['it', 'en', 'fr'] }
  },
  mounted() {
    this.updateurl()
  
  },
  methods: {
    updateurl() {
      let locale = window.location.pathname.replace(/^\/([^\/]+).*/i,'$1');
      console.log(locale, this.$i18n.locale)
      if (locale != this.$i18n.locale) {
        this.$router.replace(`/${this.$i18n.locale}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.locale-changer {
  height: 20px;
  position: relative;
}
.lang-icon,
select {
  display: inline-block;
  cursor: pointer;
  position: relative;
  top: 0;
}
.lang-icon {
  position: absolute;
  top: 7px;
  left: 0;

}
select {
  outline: 0;
  left: 0px;
  width: 46px;

  text-align: right !important;
  &:active,
  &:focus {
    outline: 0;
  }
  option {
    background: black;
    color: white;
  }
}
</style>
